module.exports = __webpack_public_path__ + "static/media/texbg.ffe0aea3.jpg";